import type { TrackingEvent, TrackingPayload } from '../types'

const useExperimentsEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => ({
  trackTriggerExperiment: (payload: {
    experiment_name: string
    experiment_variant: string
  }) => track('experiment_triggered', payload),
})

export default useExperimentsEvents
